export default __webpack_public_path__ + "static/media/dictionary.9b6fe375.jpg";